const checkboxTemplates = {
    'aoss.tower': '<div class="form-group">'+
        '<label class="form-check-label">'+
        '<input type="checkbox" class="form-check-input" checked id="temp">Temperature + Dewpoint'+
        '</label>'+
        '<label class="form-check-label">'+
        '<input type="checkbox" class="form-check-input" checked id="pres">Pressure'+
        '</label>'+
        '<label class="form-check-label">'+
        '<input type="checkbox" class="form-check-input" checked id="wS">Wind Speed'+
        '</label>'+
        '<label class="form-check-label">'+
        '<input type="checkbox" class="form-check-input" checked id="wD">Wind Direction'+
        '</label>'+
        '<label class="form-check-label">'+
        '<input type="checkbox" class="form-check-input" checked id="aP">Precipitation'+
        '</label>'+
        '<label class="form-check-label">'+
        '<input type="checkbox" class="form-check-input" checked id="sF">Solar Flux'+
        '</label>'+
        '</div>',
    'mendota.buoy': '<div class="form-group">'+
        '<label class="form-check-label">'+
        '<input type="checkbox" class="form-check-input" checked id="temp">Temperature + Dewpoint'+
        '</label>'+
        '<label class="form-check-label">'+
        '<input type="checkbox" class="form-check-input" checked id="rh">Relative Humidity'+
        '</label>'+
        '<label class="form-check-label">'+
        '<input type="checkbox" class="form-check-input" checked id="wS">Wind Speed'+
        '</label>'+
        '<label class="form-check-label">'+
        '<input type="checkbox" class="form-check-input" checked id="wD">Wind Direction'+
        '</label>'+
        '<label class="form-check-label">'+
        '<input type="checkbox" class="form-check-input" checked id="chlor">Chlorophyll'+
        '</label>'+
        '<label class="form-check-label">'+
        '<input type="checkbox" class="form-check-input" checked id="phyco">Phycocyanin'+
        '</label>'+
        '</div>'
};

const controlPanelTemplate = '<div class="row" id="control-panel-row">'+
'<div id="show-hide-boxes" class="col-md-12">'+
'</div>'+
'<div class = "col-md-9">'+
'<div class="row" style="padding: 0 1em;">'+
'<div class="form-group">'+
'<table style="width:100%">'+
'<tr>'+
'<td>'+
'<div class="radio">'+
'<label><input type="radio" id="last_x_days" name="time_select">'+
'Recent Data:'+
'</label>'+
'</div>'+
'</td>'+
'<td>'+
'<select class="form-control" id="dropDownId">'+
'<option selected value="realtime">Realtime Update</option>'+
'<option value="-1:00:00">Past 1 Hour</option>'+
'<option value="-2:00:00">Past 2 Hours</option>'+
'<option value="-3:00:00">Past 3 Hours</option>'+
'<option value="-6:00:00">Past 6 Hours</option>'+
'<option value="-12:00:00">Past 12 Hours</option>'+
'<option value="-18:00:00">Past 18 Hours</option>'+
'<option value="-24:00:00">Past 24 Hours</option>'+
'<option value="-96:00:00">Past 4 Days</option>'+
'</select>'+
'</td>'+
'<td style="padding-left:.5em">'+
'<div class="radio">'+
'<label><input type="radio" id="date_range" name="time_select">'+
'Date Range:'+
'</label>'+
'</div>'+
'</td>'+
'<td>'+
'<input class="form-control" style="padding 0.5em 0;" id="Start-date-picker" type="text" placeholder="YYYY-MM-DD"/>'+
'</td>'+
'<td>to </td>'+
'<td>'+
'<input class="form-control" style="padding 0.5em 0;" id="End-date-picker" type="text" placeholder="YYYY-MM-DD"/>'+
'</td>'+
'<td>'+
'<button class="btn btn-primary btn-block" id="plot-btn">Plot</button>'+
'</td>'+
'</tr>'+
'</table>'+
'</div>'+
'</div>'+
'</div>'+
'</div>'
;
module.exports = {
    controlPanelTemplate:controlPanelTemplate,
    checkboxTemplates:checkboxTemplates
}
